// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23hWB","buttons":"styles_buttons__1ZxmN"};